import { render } from "./CategoriaViews.vue?vue&type=template&id=4da6699c&scoped=true"
import script from "./CategoriaViews.vue?vue&type=script&lang=js"
export * from "./CategoriaViews.vue?vue&type=script&lang=js"

import "./CategoriaViews.vue?vue&type=style&index=0&id=4da6699c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da6699c"]])

export default __exports__